import {IMPORT_ENDPOINT} from "../../config";
import {createInstance} from "./createInstance";
const instance = createInstance(IMPORT_ENDPOINT);
export default instance;
